import { render, staticRenderFns } from "./DuplicateTemplateForm.vue?vue&type=template&id=0fb6ee8a&"
import script from "./DuplicateTemplateForm.vue?vue&type=script&lang=js&"
export * from "./DuplicateTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports